import React, {Button, Component, useState } from "react";

// components
import PageTitle from "../../components/PageTitle/PageTitle";
import Cookies from 'universal-cookie';
import EmptyPage from '../../widgets/EmptyPage';
import LoadingOverlay from 'react-loading-overlay';
import _ from '../../utils/languages/languages';
import GetIntermediariesService from '../../services/getIntermediaries';
import Table from '../../widgets/tables/IntermediariesTable';
import ManageIntermediary from '../../services/manageIntermediary';

export default class GeneralListPage extends React.Component {

  constructor(props){
    super (props)
  
    this.pageDiv = {
      border: '1px solid #cccccc',
      padding: 10
    };
  
    this.section = this.props.section
    if (this.section == undefined){
      const pathname = props.location.pathname;
      this.section = pathname.substring(8, pathname.length);
    }

    this.pageTitle = props.pageTitle;
    this.pageName = props.pageName;
    if (this.pageName == undefined){
      this.pageName = this.section;
    }

    this.eventslist = [];

    this.state = {
      testo: '',
      menuBackground: '#ffffff',
      menuItemColor: '#000000',
      fontSize: 50,
      fontBold: false,
      logoPicture: '',
      logoMargin: 0,
      titleColor: '#000000',
      titleSize: 18,
      isLoading: false,
      addElementVisible: false
    }

    this.grid = 2;

    this.intermediariesCompanies = [];
    this.intermediariesInvestors = [];
    this.pageTitle = "Intermediaries";

    this.state = {

    };
  }

  async reload (){
    const cookies = new Cookies();
    const username = cookies.get('username', { path: '/' });
    const token = cookies.get('token', { path: '/' });
    const currentEventId = cookies.get('currentEventId', { path: '/' });
    this.intermediariesCompanies = await GetIntermediariesService(username, token, currentEventId, 'company');
    this.intermediariesInvestors = await GetIntermediariesService(username, token, currentEventId, 'investor');

    this.setState({});
  }

  async componentDidMount(){
    this.reload();

  }

  render () {

    const defaultFontValue = {
      fontFamily: 'Montserrat',
      fontSize: 21,
      color: '#555555'
    }

    var headCells = [
      { id: 'name', numeric: false, disablePadding: true, label: 'Name' },
      { id: 'website', numeric: true, disablePadding: false, label: 'Website' },
      { id: 'username', numeric: true, disablePadding: false, label: 'Username' },
    ];

    function createData(name, website, username) {
      return { name, website, username};
    }

    var rows = [];
    this.eventslist.length > 0 && this.eventslist.map((v, k) => {
      rows.push(createData(v.name, v.website, v.username));
    });

    const cookies = new Cookies();
    const currentEventName = cookies.get('currentEventName', { path: '/' });

    if (currentEventName == '' || currentEventName == undefined){
      return <EmptyPage />;
    }

    return (
      <>
      <LoadingOverlay
      active={this.state.isLoading}
      styles={{
        content: (base) => ({
          position: 'relative',
          width: '100%',
          top: '200px'
        })
      }}
      spinner
      text={_.tr('Loading your content...')}
      >
        <PageTitle title="Company intermediaries" button="ADD" onClick={() => {
          const cookies = new Cookies();
          cookies.set('intermediaryType', 'company', { path: '/' });
          window.location.href = '/#/app/newintermediary';

        }}/>
        <Table headCells={headCells} type="company" rows={this.intermediariesCompanies} onEventClick={(row) => {
          cookies.set('currentIntermediary', row, { path: '/' });
          window.location.href = '/#/app/editintermediary';
          } 
        }
        
        onDelete={async (intermediaryId) => {
          if (window.confirm("Delete the intermediary?")) {

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
      
            let res = await ManageIntermediary (username, token, intermediaryId, '', '', '', '', '', '', '', true);

            if (res.result != 'ok'){
              alert ('An error occurred while deleting the intemediary.')
            } else {
              this.reload();            
            }
          }
        }}
        />

        <PageTitle title="Investor intermediaries" button="ADD" onClick={() => {
          const cookies = new Cookies();
          cookies.set('intermediaryType', 'investor', { path: '/' });
          window.location.href = '/#/app/newintermediary';
        }}/>
        <Table headCells={headCells} type="investor" rows={this.intermediariesInvestors} onEventClick={(row) => {
          cookies.set('currentIntermediary', row, { path: '/' });
          window.location.href = '/#/app/editintermediary';
        }} 
        
        onDelete={async (intermediaryId) => {
          if (window.confirm("Delete the intermediary?")) {

            const cookies = new Cookies();
            const username = cookies.get('username', { path: '/' });
            const token = cookies.get('token', { path: '/' });
      
            let res = await ManageIntermediary (username, token, intermediaryId, '', '', '', '', '', '', '', true);

            if (res.result != 'ok'){
              alert ('An error occurred while deleting the intemediary.')
            } else {
              this.reload();            
            }
          }
        }}
        />

        </LoadingOverlay>
      </>
    );
  }

}

